import { lazy, Suspense } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { LangProvider } from './context/LangContext';
import ProtectedRoute from './components/common/ProtectedRoute';
import ErrorBoundary from './components/common/ErrorBoundary';
import LoadingSpinner from './components/common/LoadingSpinner';

const Home = lazy(() => import('./pages/Home'));
const AdminLogin = lazy(() => import('./pages/AdminLogin'));
const AdminPanel = lazy(() => import('./pages/AdminPanel'));
const CartaPage = lazy(() => import('./pages/CartaPage'));
const WhatsAppMenuPage = lazy(() => import('./pages/WhatsAppMenuPage'));
const NotFound = lazy(() => import('./pages/NotFound'));

function App() {
  return (
    <BrowserRouter>
      <ErrorBoundary>
        <AuthProvider>
          <LangProvider>
            <Suspense fallback={<LoadingSpinner />}>
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/admin/login" element={<AdminLogin />} />
                <Route
                  path="/admin"
                  element={
                    <ProtectedRoute>
                      <AdminPanel />
                    </ProtectedRoute>
                  }
                />
                <Route path="/carta/mercado" element={<CartaPage sucursal="mercado" />} />
                <Route path="/carta/leguizamon" element={<CartaPage sucursal="leguizamon" />} />
                <Route path="/pedido/mercado" element={<WhatsAppMenuPage sucursal="mercado" />} />
                <Route path="/pedido/leguizamon" element={<WhatsAppMenuPage sucursal="leguizamon" />} />
                <Route path="*" element={<NotFound />} />
              </Routes>
            </Suspense>
          </LangProvider>
        </AuthProvider>
      </ErrorBoundary>
    </BrowserRouter>
  );
}

export default App;
